import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { GetListTypeDetail } from "../services/form";



const useListTypeDetail = () => {

    // States
    const [listTypeDetail, setListTypeDetail] = useState<IGroupKey[]>([]);
    const [loadingTypesDetail, setLoadingTypesDetail] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetTypeDetail();
    }, [])

    // Handles
    const handleGetTypeDetail = () => {
        setLoadingTypesDetail(true);
        tryCatch(() => {
            GetListTypeDetail()
                .then((response) => {
                    setListTypeDetail(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingTypesDetail(false));
        })
    }

    return {
        listTypeDetail,
        loadingTypesDetail
    }
}


export default useListTypeDetail;